export const SPECS = {
  UseDeliveryOptionsLibInExpress: 'specs.ecom.UseDeliveryOptionsLibInExpress',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ErrorHandlerOnCheckout: 'specs.ecom.ErrorHandlerOnCheckout',
  UseExpressCheckoutSettings: 'specs.ecom.UseExpressCheckoutSettings',
  FixAdditionalFeeWithoutCode: 'specs.ecom.FixAdditionalFeeWithoutCode',
  UseAdditionalFeeTranslatedNameExpress: 'specs.ecom.UseAdditionalFeeTranslatedNameExpress',
  ParallelPromisesInExpressButtonsInit: 'specs.ecom.ParallelPromisesInExpressButtonsInit',
  SendBIEventOnExpressButtonsPresented: 'specs.ecom.SendBIEventOnExpressButtonsPresented'
};
//# sourceMappingURL=SPECS.js.map